import { capitalizeFirstLetter } from "./capitalize";

export const getInitials = (string) =>
  capitalizeFirstLetter(
    string
      ?.split(" ")
      .map((n) => n[0])
      .join(" ")
  );
